module.exports = __webpack_public_path__ + "img/education2.f3d666b2.jpeg";